import * as z from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const SaveStatementPdfsEvent = BaseLoanEvent.extend({
  type: z.literal('saveStatementPdfs'),
  statements: z.array(
    z.object({
      paymentDueId: PaymentDueId,
      url: z.string(),
      disableMailTask: z.boolean().optional(),
    }),
  ),
});
export type SaveStatementPdfsEvent = z.infer<typeof SaveStatementPdfsEvent>;
